import axios from "axios";

const myAxiosV2 = axios.create({
  baseURL: process.env.REACT_APP_API_V2_BASE_URL,
});

let unauthorizedCallback = null;
let navigateFunction = null;

export const setUnauthorizedCallback = (callback) => {
  unauthorizedCallback = callback;
};

export const setNavigateFunction = (navigate) => {
  navigateFunction = navigate;
};

// Add request interceptor for setting auth token
myAxiosV2.interceptors.request.use((config) => {
  const jwtToken = localStorage.getItem("jwtToken");
  config.headers.Authorization = jwtToken ? "Bearer " + jwtToken : null;
  
  // Add impersonation token if present
  const impersonationToken = localStorage.getItem("impersonation_token");
  if (impersonationToken) {
    config.headers["X-Impersonation-Token"] = impersonationToken;
  }
  config.headers["X-Region"] = "US";
  return config;
});

myAxiosV2.interceptors.response.use(
  (response) => response,
  (error) => {
    const isChatCreateToken =
      error.config && error.config.url.includes("/business/chat/create-token");

    // Handle 401 Unauthorized (token expired/invalid)
    if (error.response && error.response.status === 401) {
      // Clear tokens and user data
      localStorage.removeItem("token");
      localStorage.removeItem("jwtToken");
      localStorage.removeItem("userData");
      localStorage.removeItem("impersonation_token");
      localStorage.removeItem("original_admin_token");
      
      // Call unauthorized callback if set (should trigger logout)
      if (unauthorizedCallback) {
        unauthorizedCallback();
      } else if (navigateFunction) {
        navigateFunction("/login");
      } else {
        // Fallback: reload page to trigger RouteGuard logout
        window.location.href = "/login";
      }
    }
    
    // Handle 403 Forbidden (permission denied)
    if (error.response && error.response.status === 403) {
      if (!isChatCreateToken) {
        if (unauthorizedCallback) {
          unauthorizedCallback();
        } else if (navigateFunction) {
          // navigateFunction("/business/billing");
        } else {
          console.error("Unauthorized");
        }
      }
    }
    return Promise.reject(error);
  }
);

export default myAxiosV2;
